import posthog from "posthog-js";

export function identifyUser(
	userId: string,
	properties?: Record<string, unknown>,
) {
	posthog.identify(userId, properties);
}

export function resetUser() {
	posthog.reset();
}

export function groupUser(groupType: string, groupKey: string) {
	posthog.group(groupType, groupKey);
}
